<template>
    <rkm-overlay>
        <rkm-layout-body title="Livro de talidomida">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="!!id"
                    :disabled="!hasPaginasEmUso"
                    @click="$refs.Form.print()"
                    color="primary"
                >
                    Imprimir
                </rkm-button>

                <rkm-button
                    v-if="!id"
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>

                <rkm-button
                    v-else-if="model.statusId === enums.livroStatus.ABERTO"
                    @click="$refs.Form.fecharLivro()"
                    color="success"
                >
                    Fechar livro
                </rkm-button>

                <rkm-button
                    v-else-if="model.statusId === enums.livroStatus.FECHADO"
                    @click="$refs.Form.printTermoFechamento()"
                    color="primary"
                >
                    Imprimir termo de fechamento
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    @model-load="model = $event"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/farmacia/livro-talidomida/Form'

// Others.
import livroStatus from '@/enums/farmacia/livroStatus'
import { mapActions } from 'vuex'

export default {
    components: { Form },
    computed: {
        hasPaginasEmUso() {

            return ('paginas' in this.model) && this.model.paginas.length > 0
        }
    },
    data: () => ({
        model: {},
        enums: {
            livroStatus,
        },
    }),
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {

            if (this.id) {

                this.redirectToList()
            }
            else {

                this.showExitConfirmation(async () => {

                    this.unsetShowExitFormConfirmation()
                    this.redirectToList()
                })
            }
        },
        handleSave() {

            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        redirectToList() {

            this.$router.push({ name: 'farmacia-livro-talidomida-index' })
        }
    },
    mounted() {

        if (!this.id) {

            this.setShowExitFormConfirmation()
        }
    },
    props: {
        id: { type: Number, default: null }
    },
}
</script>